import script from "./BuyTicketSticky.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyTicketSticky.vue?vue&type=script&setup=true&lang=ts"

import "./BuyTicketSticky.vue?vue&type=style&index=0&id=697a80fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-697a80fe"]])

export default __exports__